/**token购买卡片 */
<template>
  <div class="token-purchase-cards">
    <div
      class="purchase-card"
      v-for="item in data"
      :key="item.id"
      :class="{ active: activeDiscountId == item.id }"
      @click="handleChange(item.id)"
    >
      <div class="tag" v-if="item.tag">{{ item.tag }}</div>
      <div class="label">
        {{ item.label }}
      </div>
      <div class="price">￥{{ item.purchasePrice }}</div>
      <div class="original-price" v-if="item.originalPrice">
        ￥{{ item.originalPrice }}
      </div>
      <el-tag class="unit-price">{{ item.unitPrice }}/万token</el-tag>
      <!--占位-->
      <div v-if="!item.originalPrice" style="height: 14px"></div>
    </div>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  nextTick,
  defineExpose,
  watch,
} from "vue";
const emits = defineEmits(["update:value"]);

const props = defineProps({
  data: {
    type: Array,
    required: () => [],
  },
  value: {
    type: Number,
    default: null,
  },
});

const activeDiscountId = ref(props.value);

watch(
  () => props.value,
  (newVal, oldVal) => {
    activeDiscountId.value = newVal;
  },
  { immediate: true, deep: true }
);

const handleChange = (id) => {
  emits("update:value", id);
};
</script>

<style lang="scss" scoped>
.token-purchase-cards {
  display: flex;
  gap: 20px;
  .purchase-card {
    width: 220px;
    height: 135px;
    padding: 0 20px;
    border-radius: 10px;
    border: 2px solid #f7f7f7;
    background-color: #f7f7f7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    position: relative;
    .tag {
      border-radius: 5px 2px 16px 1px;
      background: linear-gradient(
        91.49deg,
        rgba(255, 46, 74, 1) 0.98%,
        rgba(253, 129, 16, 1) 98.21%
      );
      height: 23px;
      position: absolute;
      top: -10px;
      left: -1px;
      color: #fff;
      font-size: 12px;
      padding: 0 12px 0 7px;
      display: flex;
      align-items: center;
    }
    .label {
      color: #383838;
      font-size: 16px;
      font-weight: 550;
      margin-top: 10px;
    }
    .price {
      color: #ff2e4a;
      font-size: 28px;
      font-weight: 550;
    }
    .original-price {
      font-size: 12px;
      color: #bcbcbc;
      text-decoration: line-through;
    }
    .unit-price {
      border-radius: 13px;
      background-color: #ffffff;
      color: #bcbcbc;
      font-size: 12px;
      height: 20px;
      padding: 0 10px;
      border: none;
    }
  }
  .purchase-card:hover {
    border: 2px solid #ffd58d;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(255, 213, 141, 0.2);
    .unit-price {
      background-color: #fff8ea;
      color: #d99800;
    }
  }
  .purchase-card.active {
    border: 2px solid #ffd58d;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(255, 213, 141, 0.2);
    .unit-price {
      background-color: #fff8ea;
      color: #d99800;
    }
  }
}
</style>
